export const DIMENSIONS = [
  { key: "foundations", label: "Foundations", short: "Foundations", color: "accent" },
  { key: "awareness", label: "Awareness", short: "Awareness", color: "accent" },
  { key: "capability", label: "Capability", short: "Capability", color: "accent" },
  { key: "people", label: "People & Change", short: "People", color: "accent" },
  { key: "vision", label: "Vision", short: "Vision", color: "accent" },
  { key: "capacity", label: "Capacity", short: "Capacity", color: "accent" },
  { key: "value", label: "Value Discipline", short: "Value", color: "accent" },
  { key: "workforce", label: "Workforce Model", short: "Workforce", color: "accent" },
];
